/*
* Gateway/Comment API
* */

import {
    RequestConfigFunction,
} from 'app/types/request.types'

type GatewayCommentRequests = {
    filterRequestAll: RequestConfigFunction<{
        gatewayId: number, params?: Record<string, any>
    }>,
    create: RequestConfigFunction<{gatewayId: number}>,
    archive: RequestConfigFunction<{gatewayId: number}>,
}

const gatewayCommentRequests: GatewayCommentRequests = {
    filterRequestAll: ({
        gatewayId,
        params,
    }) => {
        return {
            url: `gateway/${gatewayId}/comment/filter-request/all`,
            method: 'POST',
            ...params,
        }
    },
    create: ({
        gatewayId,
    }) => {
        return {
            url: `gateway/${gatewayId}/comment`,
            method: 'POST',
        }
    },
    archive: ({
        gatewayId,
    }) => {
        return {
            url: `gateway/comment/${gatewayId}/archive`,
            method: 'PATCH',
        }
    },
}

export default gatewayCommentRequests
